// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".lookbook-content{margin:-24px 0 -25px;overflow:hidden}@media only screen and (min-width:992px){.lookbook-content{margin:-74px 0 0;padding-bottom:68px}}", ""]);
// Exports
module.exports = exports;
